import { SignalrService } from './core/services/signalr.service';
import { Component, Injectable, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LogService } from './core/services/log.service';
import { constants } from './config/constant';
import { environment } from 'src/environments/environment';
import { PulseLoaderComponent } from './core/common/pulse-loader/pulse-loader.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'suncash-kiosk';
  baseUrl?: string;

  constructor(private config: constants, private router: Router, private signalR: SignalrService, private logger: LogService) {
  }

  ngOnInit() {
    this.baseUrl = window.location.origin;
    localStorage.setItem('baseUrl', this.baseUrl);
  }
}
